import { Translate } from "components/common/Translate/Translate";
import { type ColorFormat } from "store/features/colorPicker/types";
import { RGB } from "./RGB/RGB";
import { HSL } from "./HSL/HSL";
import { HSV } from "./HSV/HSV";
import { CMYK } from "./CMYK/CMYK";

export interface ColorComponentsProps {
    hex: string;
    format: ColorFormat;
}

export const ColorComponents = ({ hex, format }: ColorComponentsProps) => {
    if (format === "hex") return null;
    return (
        <div className="flex flex-col gap-4">
            <div className="text-lg font-semibold">
                <Translate keyName="edit-color" />
            </div>
            <div
                className="grid items-center gap-4"
                style={{
                    gridTemplateColumns: `auto 1fr auto`,
                }}
            >
                {format === "rgb" ? <RGB hex={hex} /> : null}
                {format === "hsv" ? <HSV hex={hex} /> : null}
                {format === "hsl" ? <HSL hex={hex} /> : null}
                {format === "cmyk" ? <CMYK hex={hex} /> : null}
            </div>
        </div>
    );
};
